import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/telemetry";

interface FreelancerSearch {
  loading: boolean;
  total: number;
  /** The names of the filters that are on, never their values. */
  filtros: string[];
  /** One `filtro_<name>` property per active filter, with its values, plus the search text as `filtro_busca`. */
  valoresFiltros: Record<string, string | string[]>;
  comBusca: boolean;
  comVaga: boolean;
  pagina: number;
  /** Changes when the person changes the search, the filters, the order or the page. */
  key: string;
}

/** One `busca.executar` per search that finished loading, plus `busca.sem_resultado` when it found nobody. */
export function useTrackFreelancerSearch({ loading, total, filtros, valoresFiltros, comBusca, comVaga, pagina, key }: FreelancerSearch): void {
  const lastTracked = useRef<string | null>(null);
  const latest = useRef({ filtros, valoresFiltros });
  latest.current = { filtros, valoresFiltros };

  useEffect(() => {
    if (loading || lastTracked.current === key) return;
    lastTracked.current = key;
    const { filtros: active, valoresFiltros: values } = latest.current;
    trackEvent("busca.executar", {
      contexto: { ...values, total, filtros: active, filtros_n: active.length, com_busca: comBusca, com_vaga: comVaga, pagina },
    });
    if (total === 0) {
      trackEvent("busca.sem_resultado", {
        contexto: { ...values, lista: "freelancers", filtros: active, filtros_n: active.length, com_busca: comBusca },
      });
    }
  }, [loading, key, total, comBusca, comVaga, pagina]);
}
